<template>
  <div>
    <div class="d-flex justify-space-between align-center pa-4 pa-md-2">
      <breadcrumbs
        headline="Thu phí"
        :link="[{ text: 'Thu phí', href: '../sales' }]"
      />
    </div>
    <v-row class="pa-0 ma-0">
      <v-col cols="12" sm="12" md="8" xl="8" class="py-0">
        <v-card elevation="1">
          <product-selector
            class="pa-4"
            :products.sync="products"
          ></product-selector>
        </v-card>
      </v-col>
      <v-col cols="12" sm="12" md="4" xl="4" class="py-0">
        <v-card class="pa-4">
          <multi-bill
            :products="products"
            :students="students"
            ref="multiForm"
            v-if="students && students.length"
          ></multi-bill>
          <bill :products="products" ref="form" v-else></bill>
          <v-divider></v-divider>
          <div class="d-flex justify-space-between align-center">
            <v-checkbox
              color="amber"
              v-model="isPrintBill"
              dense
              label="In hóa đơn"
            ></v-checkbox>
            <div class="text-right">
              <v-btn
                dark
                depressed
                class="green"
                @click="save()"
                :loading="loading"
              >
                Tạo/Lưu Đơn
              </v-btn>
            </div>
          </div>
        </v-card>
      </v-col>
    </v-row>
    <student-new-dialog
      :state="dialog"
      @done="updateStudent"
      :defaultPhone="phone"
      :defaultName="name"
      :defaultEmail="email"
    />
    <bill-print-dialog :state="printBillDialog" :bill="bill" />
  </div>
</template>
<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import Breadcrumbs from '@/components/layout/Breadcrumbs'
import Bill from '@/modules/sales/Bill.vue'
import MultiBill from '@/modules/sales/SaleEditMultiStudentsForm.vue'
import ProductSelector from '@/modules/sales/SaleProductSelector.vue'
import StudentNewDialog from '@/modules/student/StudentNewDialog'
import BillPrintDialog from '@/modules/bill/BillPrintDialog.vue'

export default {
  components: {
    Bill,
    ProductSelector,
    MultiBill,
    Breadcrumbs,
    StudentNewDialog,
    BillPrintDialog
  },
  data() {
    return {
      loading: false,
      singleSelect: false,
      selected: [],
      newProduct: null,
      products: [],
      isPrintBill: true,
      printBillDialog: false,
      dialog: false,
      lead: {},
      phone: '',
      email: '',
      name: '',
      bill: {}
    }
  },
  computed: {
    ...mapGetters('app', ['department']),
    ...mapGetters('auth', ['profile']),
    ...mapState('sale', ['students'])
  },
  watch: {
    products() {
      console.log(this.products)
    }
  },
  methods: {
    ...mapActions('sale', ['createBill', 'createLead', 'updateLead']),
    async save() {
      console.log('save')
      if (!this.students || !this.students.length) {
        if (!this.$refs.form.validate()) return
        await this.createLeadAndBill()
      } else {
        if (!this.$refs.multiForm.validate()) return
        await this.createLeads()
      }
    },
    updateStudent(student) {
      this.updateLead({ ...this.lead, student: student.id })
      if (!this.isPrintBill) {
        this.$dialog.confirm({
          title: 'Khởi Tạo Thành Công',
          text: 'Tạo và lưu đơn Hàng Thành công',
          okText: 'ok',
          cancelText: 'Đã hiểu',
          done: async () => {
            this.reset()
          }
        })
      }
    },
    async createLeads() {
      this.loading = true
      const leads = this.$refs.multiForm.getValues()
      leads.map(async lead => {
        await this.createLead({
          data: {
            ...lead,
            department: this.department.id,
            staff: this.profile.id
          }
        })
      })
      this.$alert.success('Tạo Đơn hàng thành công!')
      this.loading = false
    },
    reset() {
      this.lead = {}
      this.bill = {}
      this.$refs.form.reset()
    },
    async createLeadAndBill() {
      this.loading = true
      const bill = this.$refs.form.getValues()
      this.bill = await this.createBill({
        data: {
          ...bill,
          department: this.department.id,
          staff: this.profile.id
        }
      })

      this.lead = await this.createLead({
        data: {
          ...bill,
          bills: [this.bill.id],
          department: this.department.id,
          staff: this.profile.id
        }
      })
      if (this.isPrintBill) this.printBillDialog = !this.printBillDialog
      if (!bill.student) {
        this.$dialog.confirm({
          title: 'Tạo Học Viên',
          text:
            'Đơn hàng này chưa được liên kết với một học viên! Bạn có muốn tạo một học viên ?',
          okText: 'Có',
          cancelText: 'Bỏ Qua',
          done: async () => {
            this.name = this.bill.customerName
            this.email = this.bill.customerEmail
            this.phone = this.bill.customerPhone
            this.dialog = !this.dialog
          }
        })
      }
      this.$alert.success('Tạo Đơn hàng và Hóa đơn thành công!')
      this.loading = false
    }
  }
}
</script>
<style scoped></style>
